<app-subsection-title key="project.steps.rfq.invitationPreview.file.upload.title" />

<app-rfq-document-upload-content
  [tenderId]="tenderId()"
  (phaseCompleted)="isPhaseCompleted.set($event)"
/>

<p-divider></p-divider>
<div class="flex justify-end mt-6">
  @if (isPhaseCompleted()) {
    <p-button
      label="{{ 'provider.questionnaire.finishButton' | transloco }}"
      (onClick)="finishPhase()"
    ></p-button>
  }
</div>
